import React from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, ownerOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#EFEBDE]">
        <Loader2 size={32} className="animate-spin text-[#2C5F3A]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;

  if (ownerOnly && !user.is_owner) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#EFEBDE] px-6 text-center">
        <ShieldAlert size={44} className="text-[#2C5F3A]" strokeWidth={1.5} />
        <h1 className="mt-6 font-display font-semibold text-3xl md:text-4xl tracking-tight text-[#16281C]">
          Owner access only
        </h1>
        <p className="mt-4 font-body text-base text-[#4C5C50] max-w-md">
          You're signed in as <span className="text-[#16281C] font-medium">{user.email}</span>, but this area is restricted to the site owner.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-[#2C5F3A] text-[#EFEBDE] font-mono text-xs tracking-[0.2em] uppercase px-7 py-4 hover:bg-[#367A49] transition-colors"
        >
          Back to site
        </Link>
      </div>
    );
  }

  return children;
};
